var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sid-select"},[_c('v-select',_vm._b({staticClass:"custom-select",attrs:{"options":_vm.options,"reduce":val => val.value},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'v-select',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }